module.exports = __webpack_public_path__ + "assets/img/32_517.f6ee1596.jpg";